import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="font-heading text-xl font-bold uppercase tracking-tight mb-4">
              Pure Epox
            </h3>
            <div className="flex items-start text-slate-400 font-body">
              <MapPin size={20} weight="bold" className="mr-3 mt-1 text-sky-500 flex-shrink-0" />
              <span>
                Steubenstraße 23<br />
                35576 Wetzlar<br />
                Deutschland
              </span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold uppercase tracking-tight mb-4">
              Kontakt
            </h4>
            <div className="space-y-3">
              <a 
                href="tel:+4916092653278" 
                className="flex items-center text-slate-400 hover:text-white transition-colors font-body"
                data-testid="footer-phone"
              >
                <Phone size={20} weight="bold" className="mr-3 text-sky-500 flex-shrink-0" />
                +49 160 92653278
              </a>
              <a 
                href="mailto:pureepox@gmail.com" 
                className="flex items-center text-slate-400 hover:text-white transition-colors font-body"
                data-testid="footer-email"
              >
                <EnvelopeSimple size={20} weight="bold" className="mr-3 text-sky-500 flex-shrink-0" />
                pureepox@gmail.com
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold uppercase tracking-tight mb-4">
              Rechtliches
            </h4>
            <div className="flex flex-col space-y-3">
              <Link 
                to="/impressum" 
                className="text-slate-400 hover:text-white transition-colors font-body"
                data-testid="footer-link-impressum"
              >
                Impressum
              </Link>
              <Link 
                to="/datenschutz" 
                className="text-slate-400 hover:text-white transition-colors font-body"
                data-testid="footer-link-datenschutz"
              >
                Datenschutzerklärung
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <p className="text-slate-500 text-sm font-body text-center">
            © {currentYear} Pure Epox. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
